import { useCallback, useEffect } from 'react';
import { styled } from 'styled-components';

import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Text } from 'components/Text/Text';
import { useI18n } from 'i18n/hooks/useI18n';
import { colors } from 'theme/theme';
import { LocalProductNotificationType } from 'types/LocalNotification/LocalProductNotificationType';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEventOnce } from 'utils/analytics/track/trackEventOnce';
import { getStaticImageSrc } from 'utils/getImageSrc';
import { clearAdStore } from 'zustand-stores/adStore';
import { dismissLocalNotification } from 'zustand-stores/localNotificationsStore';

const CloseButton = styled(Button)`
  opacity: 0.999; /* is invisible without this, why? */
`;

export function MergerBanner() {
  const { i18n } = useI18n();

  const handleDismiss = useCallback(() => {
    dismissLocalNotification(LocalProductNotificationType.MERGER_BANNER);
    clearAdStore();
  }, []);

  useEffect(() => {
    trackEventOnce('Displayed: VM Merger Ad', {
      context: 'Header Banner',
    });
  }, []);

  return (
    <Box
      qaId="banner-ad"
      data-ad-type="merger"
      position="relative"
      zIndex={101}
      bg="#CFF0FF"
      color="white"
      display="flex"
      pr="auto"
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage={`url('${getStaticImageSrc('merger-banner-base.svg')}')`}
        backgroundPosition="left center"
        backgroundRepeat="repeat-x"
      />
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage={[
          `url('${getStaticImageSrc('merger-banner-overlay-sm.svg')}')`,
          `url('${getStaticImageSrc('merger-banner-overlay-lg.svg')}')`,
          null,
          null,
        ]}
        backgroundPosition="right center"
        backgroundRepeat="no-repeat"
      />
      <Box
        position="relative"
        minHeight={80}
        width={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="nowrap"
      >
        <Box
          pr={10}
          pl={[16, 24, null, null]}
          mt={[16, 24, null, null]}
          mb={[16, 24, null, null]}
          fontSize={[14, 16, null, 18]}
          color={colors.darkContentGrey}
        >
          <Text
            display="inline"
            fontWeight="bold"
            marginRight={10}
            color={colors.darkContentGrey}
          >
            {i18n('Good News!')}
          </Text>
          {i18n('VolunteerMatch is now part of Idealist 🎉')}
        </Box>
        <Button
          type="link"
          size="small"
          href="/volunteermatch"
          variant="primary"
          onClick={() => {
            trackClicked('Clicked: VM Merger Ad', {
              cta_type: 'Button',
              button_text: i18n('See What’s New'),
              url: '/volunteermatch',
              context: 'Header Banner',
            });
            handleDismiss();
          }}
          style={{ flexShrink: '0' }}
        >
          <Box minHeight={24} display="flex" alignItems="center">
            <Box display="block">{i18n('See What’s New')}</Box>
          </Box>
        </Button>
      </Box>
      <CloseButton
        type="button"
        qaId="close-banner-ad-button"
        onClick={handleDismiss}
        variant="tertiary-grey"
        icon={{ type: 'normalized', name: 'close' }}
      />
    </Box>
  );
}
